import { render, staticRenderFns } from "./collectionInstallment.vue?vue&type=template&id=2538efe8&"
import script from "./collectionInstallment.vue?vue&type=script&lang=js&"
export * from "./collectionInstallment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports